import {authenticate} from '@simpleinvest/front-end-auth';
import RwAdvisorService from '@advisor/rwSdk/AdvisorService';
import {transformRiaUserData} from '@advisor/config/useAuth';

const stateObj = {
  user: null,
};

// Tracks in-flight authenticateRiaUser calls so duplicate invocations
// (e.g. AdvisorLogin.vue mounting/handling the SSO redirect more than once)
// reuse the same request instead of firing a second POST /ria-users call,
// which was causing duplicate ria_users rows to be inserted.
const riaUserAuthInFlight = new Map();

const mutations = {
  setUser(state, user) {
    const newUser = user;

    state.user = newUser;
  },
};

const actions = {
  async authenticateUser(context, {riaId, email, password}) {
    const user = await authenticate({
      clientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
      userPoolId: process.env.VUE_APP_COGNITO_USERPOOL_ID,
      email,
      env: process.env.VUE_APP_ENV,
      password,
      riaId,
    });

    context.commit('setUser', user);
  },
  authenticateRiaUser(context, payload) {
    const tokenValue = payload.idToken;

    if (riaUserAuthInFlight.has(tokenValue)) {
      return riaUserAuthInFlight.get(tokenValue);
    }

    const authPromise = RwAdvisorService.updateNSKRiaUser(tokenValue)
      .then((user) => {
        const userDetails = transformRiaUserData(user);

        context.commit('setUser', userDetails);

        return userDetails;
      })
      .finally(() => {
        if (riaUserAuthInFlight.get(tokenValue) === authPromise) {
          riaUserAuthInFlight.delete(tokenValue);
        }
      });

    riaUserAuthInFlight.set(tokenValue, authPromise);

    return authPromise;
  },
  setUser(context, user) {
    context.commit('setUser', user);
  },
};

const getters = {
  username: (state) => (state.user === null ? null : state.user.username),
  userDetails: (state) => state.user,
};

export default {
  namespaced: true,
  state: stateObj,
  mutations,
  actions,
  getters,
};
